import { ButtonLink, Header, Stack, StackItem } from '@asgard/ui-library';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import HtmlTrans from 'components/shared/HtmlTrans';
import { useI18n } from 'hooks/useI18n';
import { Link } from 'react-scroll';
import { getPublicPath } from 'utils/paths';
import * as SP from '../../HrAsAServicePage.styled';
import * as S from './Hero.styled';

export const Hero: React.FC = () => {
  const { t } = useI18n('hr-as-a-service');
  return (
    <S.Root>
      <SP.Container>
        <Stack alignment="center" gap="7xl" className="stack">
          <StackItem className="text">
            <Header as="h1" size="7xl" editorial>
              <HtmlTrans
                ns="hr-as-a-service"
                i18nKey={'hr-as-a-service.hero.title'}
              />
            </Header>

            <HtmlTrans
              ns="hr-as-a-service"
              i18nKey={'hr-as-a-service.hero.desc'}
            />

            <Link to="hrForm" href="#hrForm">
              <ButtonLink
                variant="hard"
                schema="brand2"
                startIcon={faCheckCircle}
                label={t('hr-as-a-service.hero.cta')}
                href="#hrForm"
              />
            </Link>
          </StackItem>

          <StackItem className="video">
            <img src={getPublicPath('/images/Success positive.svg')} />
          </StackItem>
        </Stack>
      </SP.Container>
    </S.Root>
  );
};
